function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as PropTypes from 'prop-types';
import React from 'react';
import SpzaComponent from './spzaComponent';
import { SpzaInstrumentService } from '@shared/services/telemetry/spza/spzaInstrument';
import { getWindow } from '@shared/services/window';
import { Constants } from '@shared/utils/constants';
import { Banner } from './banner';
import { logger } from '@src/logger';
class AppPromotionPane extends SpzaComponent {
    handleClick(telemetryLink, event) {
        const payload = {
            page: getWindow().location.href,
            action: Constants.Telemetry.Action.Click,
            actionModifier: Constants.Telemetry.ActionModifier.FirstPartyAppPromotion,
            details: JSON.stringify({
                linkType: Constants.Telemetry.ActionModifier.FirstPartyAppPromotion,
                link: telemetryLink || event && event.target && event.target.href
            })
        };
        SpzaInstrumentService.getProvider().probe('logTelemetryInfo', payload);
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier
        });
    }
    renderStoreLink(storeLink) {
        return /*#__PURE__*/ _jsx("a", {
            href: storeLink,
            className: "c-hyperlink",
            target: "_blank",
            onClick: this.handleClick.bind(this, storeLink),
            rel: "noreferrer",
            children: this.context.loc('AppPromotionPane_SeeYourOptions')
        });
    }
    renderImpl() {
        const { bannerInfo, isEmbedded } = this.props;
        if (isEmbedded) {
            return null;
        }
        if (bannerInfo) {
            const { title, imageUrl: imgURL, links, description, descriptionFallback, name, storeLink } = bannerInfo;
            return /*#__PURE__*/ _jsx(_Fragment, {
                children: title ? /*#__PURE__*/ _jsx(Banner, {
                    data: {
                        description: this.context.loc(description, descriptionFallback),
                        imgURL,
                        title,
                        links
                    }
                }) : /*#__PURE__*/ _jsx("div", {
                    className: "appPromotionPane_shorter",
                    children: /*#__PURE__*/ _jsxs("p", {
                        className: "c-subheading-5",
                        children: [
                            this.context.locParams('AppPromotionPane_Content', [
                                name,
                                ' '
                            ]),
                            this.renderStoreLink(storeLink)
                        ]
                    })
                })
            });
        }
        return null;
    }
    constructor(...args){
        super(...args), _define_property(this, "context", void 0);
    }
}
export { AppPromotionPane as default };
AppPromotionPane.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func
};
